
import {defineComponent, PropType} from "vue";
import InputText from "@/components/UI/InputText.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import ColorPicker from "@/components/UI/ColorPicker.vue";
import Subtitle from "@/components/UI/Subtitle.vue";
import {MaterialSymbolRestDto} from "@/api/pharma-cms-content-block/models";
import {MaterialSymbolRestDtoModel} from "@/models/api/pharma-cms-content-block/MaterialSymbolRestDtoModel";
import {CodeDescriptionRestDto} from "@/api/pharma-cpc-mgmt/models";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";
import {EnumClassNameCmsEnum} from "@/models/enum/EnumClassNameCmsEnum";
import {UIStateDto} from "@/dtos/UIStateDto";
import PreviewMaterialSymbol from "@/components/UI/PreviewMaterialSymbol.vue";
import {ComponentMixin} from "@/components/base/ComponentMixin";
import GenericComponentWrapper from "@/components/base/GenericComponentWrapper.vue";

export default defineComponent({
  name: "MaterialSymbolInputComponent",
  mixins: [ComponentMixin],
  components: {
    GenericComponentWrapper,
    PreviewMaterialSymbol,
    InputText,
    InputNumber,
    InputSelect,
    InputCheckboxBoolean,
    ColorPicker,
    Subtitle,
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Object as PropType<MaterialSymbolRestDto>,
      required: true,
    },
    showPreview: {
      type: Boolean,
      required: false,
      default: false
    },
    showExternalInfo: {
      type: Boolean,
      required: false,
      default: true
    },
    name: {
      type: String,
      required: false,
      default: 'default'
    },
    title: {
      type: String,
      required: false,
    },
    errors: {
      type: Object,
    }
  },
  data() {
    return {
      localDto: MaterialSymbolRestDtoModel.createWithDefaults(),
      symbolFamilyOptions: [] as CodeDescriptionRestDto[],
      symbolWeightOptions: [] as CodeDescriptionRestDto[],
      symbolGradeOptions: [] as CodeDescriptionRestDto[],
      symbolOpticalSizeOptions: [] as CodeDescriptionRestDto[],
      pageUI: UIStateDto.createWithDefaults(),
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newValue: MaterialSymbolRestDto) {
        this.localDto = MaterialSymbolRestDtoModel.cloneFrom(newValue);
      },
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async doInitialize(): Promise<void> {
      [
        this.symbolFamilyOptions,
        this.symbolWeightOptions,
        this.symbolGradeOptions,
        this.symbolOpticalSizeOptions,
      ] = await Promise.all([
        EnumRestService.getInstance().getCmsEnumValuesByClassname(EnumClassNameCmsEnum.SYMBOL_FAMILY_ENUM),
        EnumRestService.getInstance().getCmsEnumValuesByClassname(EnumClassNameCmsEnum.SYMBOL_WEIGHT_ENUM),
        EnumRestService.getInstance().getCmsEnumValuesByClassname(EnumClassNameCmsEnum.SYMBOL_GRADE_ENUM),
        EnumRestService.getInstance().getCmsEnumValuesByClassname(EnumClassNameCmsEnum.SYMBOL_OPTICAL_SIZE_ENUM),
      ]);
    },
    onChangeSymbolName(newValue: any): void {
      this.localDto.name_code = newValue
        .toLowerCase()
        .replaceAll(' ', '_');
      this.emitModelChanged();
    },
    emitModelChanged() {
      this.$emit("update:modelValue", this.localDto);
    },
  }
});
